import ConfirmTransferPage from "./ConfirmTransferPage";

export default ConfirmTransferPage;

export * from "./ConfirmTransferPage";
